import { render, staticRenderFns } from "./OperaChangeIntegralWindow.vue?vue&type=template&id=3c960be0&scoped=true&"
import script from "./OperaChangeIntegralWindow.vue?vue&type=script&lang=js&"
export * from "./OperaChangeIntegralWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaChangeIntegralWindow.vue?vue&type=style&index=0&id=3c960be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c960be0",
  null
  
)

export default component.exports